define('taoQtiItem/qtiXmlRenderer/renderers/interactions/EndAttemptInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'endAttemptInteraction',
        template : tpl
    };
});
